
module dg.lists {

    class RefreshController implements ng.IController {

        $onInit() {

        }

        private queryManipulator: dg.actions.ServerQueryManipulator;

        public refresh () {
            this.queryManipulator.executeQuery();
        }
    }
        
    angular.module('dg.lists').component('refresh', {
        bindings: {
            queryManipulator: '<'
        },
        controller: RefreshController,
        templateUrl: '/digmo/src/lists/refresh.html'
    });
}